import { AUTHENTICATED_EMPLOYEE_JWT } from "./constants";

const STAGING_ENV = "api-egtrade-staging.com";
const PROD_ENV = "api-egtrade.com";

export const API_HEADERS = {
  "Content-Type": "application/json",
  Authorization: `Bearer ${window.localStorage.getItem(AUTHENTICATED_EMPLOYEE_JWT)}`,
};

let AUTH_API_BASE_URL: string;

// TODO: Get env details from JWT token instead of window location
const hostname = window && window.location && window.location.hostname;

const baseUrls = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-auth-api/api",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-auth-api/api",
};

// Default to staging if hostname doesn't match
AUTH_API_BASE_URL = baseUrls[hostname] || "https://api-egtrade-staging.com/egtrade-auth-api/api";

export { AUTH_API_BASE_URL };
